import React from 'react';

import styles from './layout-background-loader-scss.js';

type LayoutBackgroundLoaderProps = {
  backgroundColor?: string;
};

const DEFAULT_BACKGROUND_COLOR = '#f5f5f5';

export const LayoutBackgroundLoader: React.FC<LayoutBackgroundLoaderProps> = ({
  backgroundColor = DEFAULT_BACKGROUND_COLOR,
}) => {
  return (
    <div
      className={styles.overlay}
      style={{ '--shimmer-base-color': backgroundColor } as React.CSSProperties}
    >
      <div className={styles.shimmer} />
    </div>
  );
};
